const TOUR_LEAD_CONTENT = [
  {
    content: (
      <div>
        <h2>Welcome</h2>
      </div>
    ),
    placement: 'center',
    target: 'body'
  },
  {
    title: 'Search & Filter',
    content: 'Use criteria based search and filters to view prospective leads',
    placement: 'right',
    target: '.ebz-filters-btn'
  },
  {
    title: 'Export',
    content: 'Export customized data for tracking prospective merchants',
    placement: 'bottom',
    target: '.export-btn'
  },
  {
    title: 'Create Lead',
    content: 'Add prospective merchants and schedule a demo with them',
    placement: 'bottom',
    target: '.create-lead'
  },
  {
    content: (
      <div>
        <h2>End</h2>
      </div>
    ),
    placement: 'center',
    target: 'body'
  }
];

const TOUR_LEAD_CONTENT1 = [];

export { TOUR_LEAD_CONTENT, TOUR_LEAD_CONTENT1 };
